<div class="container">
    <div>
        <app-menu />
    </div>
    <div>
      <router-outlet />
    </div>
    <div>
        <app-footer />
    </div>
</div>